export enum ScreenType {
  'Mobile',
  'Desktop',
}
